import gql from 'graphql-tag';

export default gql`
fragment OrderListItem on Order {
    id
    created_at
    user {
        id
        name
        email
        ext_id
        orders (first: 1) {
            paginatorInfo {
                total
            }
        }
    }
    contact_data {
        contact_name
        contact_email,
        contact_telephone
    }
    total_amount
    total_sum
    status {
        title
        code
    }
    shipping_method {
        id
        name
    }
    is_admin_checked
    linked_order_id
}
`;



// WEBPACK FOOTER //
// ./src/api/graphql/fragments/OrderListItem.ts